export default {
  '基础信息':'基礎資訊',
  '赛事名称':'賽事名稱',
  '请输入赛事名称':'請輸入賽事名稱',
  '副标题':'副標題',
  '请输入活动副标题':'請輸入活動副標題',
  '封面':'封面',
  '封面图片':'封面圖片',
  '请上传比例为':'請上傳比例為1:1且小於2M的PNG、JPG格式圖片',
  '周期':'週期',
  '至':'至',
  '在活动周期内参赛即可':'在活動週期內參賽即可',
  '级别':'級別',
  '请输入自定义级别':'請輸入自定義級別',
  '说明':'說明',
  '选择范围':'選擇範圍',
  '对齐方式':'對齊方式',
  '图片':'圖片',
  '视频':'影片',
  '链接':'連結',
  '表格':'表格',
  '请选择封面':'請選擇封面',
  '请选择周期':'請選擇週期',
  '请选择级别':'請選擇級別',
  '排行规则':'排行規則',
  '运动项目':'運動項目',
  '增加项目':'增加項目',
  '选择项目':'選擇項目',
  '运动方式':'運動方式',
  '支持特殊项目':'支援特殊項目',
  '强度':'強度',
  '项目名':'項目名',
  '运动强度':'運動強度',
  '确认要删除运动项目{sportSkuName}吗':'確認要刪除運動項目{sportSkuName}嗎',
  '请选择运动项目':'請選擇運動項目',
  '请填写运动强度':'請填寫運動強度',
  '运动强度填写错误':'運動強度填寫錯誤',
  '请填写运动强度':'請填寫運動強度',
  '请选择排行规则':'請選擇排行規則',
  '运动项目不能为空':'運動項目不能為空',
  '编辑项目':'編輯項目',
  '新增项目':'新增項目',
  '赛事保存成功！':'賽事保存成功！',
  '编辑赛事':'編輯賽事',
  '查看赛事':'查看賽事',
  '新增赛事':'新增賽事',
  '填写基本信息':'填寫基本資訊',
  '配置运动项目':'配置運動項目',
  '赛事列表':'賽事列表',
  '标题、参与':'標題、參與/發佈機構模糊搜尋',
  '发布赛事':'發佈賽事',
  '赛事封面':'賽事封面',
  '提前结束':'提前結束',
  '标题':'標題',
  '赛事周期':'賽事週期',
  '领域':'領域',
  '发布机构':'發佈機構',
  '发布人':'發佈人',
  '确认要删除{name}':'確認要刪除{name}嗎？',
  '删除后，无法查看该赛事！':'刪除後，無法查看該賽事！',
  '确认要提前结束{name}':'確認要提前結束{name}嗎？',
  '结束后，用户将不能继续参赛！':'結束後，用戶將不能繼續參賽！',
  '提前终止成功！':'提前終止成功！',
  '领域':'領域',
  '请选择领域':'請選擇領域',
  '选择赛事类型':'選擇賽事類型',
  '闯关挑战赛':'闖關挑戰賽',
  '学生可完成不同关卡，同时记录学生累积成绩及团队积分的比赛':'學生可完成不同關卡，同時記錄學生累積成績及團隊積分的比賽',
  '竞技排名赛':'競技排名賽',
  '记录学生单个运动项目最佳个人成绩的比赛':'記錄學生單個運動項目最佳個人成績的比賽',
  '赛事':'賽事',
  '标题':'標題'
}